export default {
  SESSION_CREATE: "session/CREATE",
  SESSION_FAILED: "session/FAILED",
  SESSION_REQUEST: "session/REQUEST",
  SESSION_CLEAR: "session/CLEAR",
  SESSION_HEADER:"X-Session-Token"
};